import React, { useCallback, useEffect } from 'react';
import { confluenceCrossFlowModalEntryPoint } from '@atlassian/jira-confluence-cross-flow-modal/entrypoint';
import { useRetros } from '@atlassian/jira-confluence-sprint-retros';
import { useEntryPoint } from '@atlassian/jira-entry-point';
import { ModalEntryPointContainer } from '@atlassian/jira-entry-point-modal-container';
import {
	JIRA_SOFTWARE_BACKLOG_END_OF_SPRINT_RETRO,
	RETRO_CONFLUENCE_CROSS_FLOW_SOURCE,
} from '@atlassian/jira-issue-create-confluence-content/src/common/constants';

const entryPointParams = {};

export default function ConfluenceRetroCrossFlowModal() {
	const [state, actions] = useRetros();

	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		confluenceCrossFlowModalEntryPoint,
		entryPointParams,
	);

	// eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
	useEffect(() => {
		if (state.loadCrossFlowModal) {
			actions.setLoadCrossFlowModal(false);
			entryPointActions.load();
		}
	}, [state.loadCrossFlowModal, entryPointActions, actions]);

	const onClose = useCallback(() => {
		actions.resetState();
	}, [actions]);

	const onComplete = ({ success }: { success?: boolean }) => {
		if (success) {
			window.location.reload();
		}
	};

	return (
		<>
			<ModalEntryPointContainer
				entryPointReferenceSubject={entryPointReferenceSubject}
				entryPointActions={entryPointActions}
				id="jira-confluence-cross-flow-modal"
				packageName="jira-confluence-cross-flow-modal"
				teamName="Confluence - Better Together"
				runtimeProps={{
					onClose,
					onComplete,
					embeddedConfluenceSource: JIRA_SOFTWARE_BACKLOG_END_OF_SPRINT_RETRO,
					crossFlowSource: RETRO_CONFLUENCE_CROSS_FLOW_SOURCE,
				}}
			/>
		</>
	);
}
